export default __webpack_public_path__ + "static/media/headwind-logo-gradient.ebf04ae9.svg";